<main class="container-geral">
  <section class="cabecalho">
    <h1 class="titulo">{{ turnoId ? ('COMPONENTS.TURNOS_FORM.titleUpdate' | transloco) : ('COMPONENTS.TURNOS_FORM.titleCreate' | transloco) }} </h1>
  </section>

  <section class="form-section">
    <p class="paragrafo-informacoes">
      {{ 'COMPONENTS.TURNOS_FORM.info' | transloco }}
    </p>

    <div class="formulario">
      <form [formGroup]="formularioTurno" class="group-form" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.TURNOS_FORM.nameLabel' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="vc_nome" type="text" class="input-form form-control" [class.invalido]="
                  formularioTurno.get('vc_nome')?.invalid &&
                  formularioTurno.get('vc_nome')?.dirty
                " placeholder="{{ 'COMPONENTS.TURNOS_FORM.namePlaceholder' | transloco }}"
              />
            }

            @if (
              formularioTurno.get('vc_nome')?.invalid &&
              formularioTurno.get('vc_nome')?.dirty
            ) {
              <small class="mensagem-validacao-form"> *{{ 'COMPONENTS.TURNOS_FORM.nameRequired' | transloco }} </small>
            }
          </div>

          <div class="col-md-6 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.TURNOS_FORM.plantLabel' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <select formControlName="fk_cliente" class="crud-select form-select input-form" [class.invalido]="
                  formularioTurno.get('fk_cliente')?.invalid &&
                  formularioTurno.get('fk_cliente')?.dirty
                "
              >
                <option value="" selected disabled>
                  {{ 'COMPONENTS.TURNOS_FORM.plantPlaceholder' | transloco }}
                </option>

                @for (cliente of clientes; track cliente.id) {
                  <option [value]="cliente.id">{{ cliente.nome }}</option>
                }
              </select>
            }
          </div>

          <div class="col-md-6">
            <label class="form-label">
              {{ 'COMPONENTS.TURNOS_FORM.startHourLabel' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="tm_hora_inicio" type="time" class="input-form form-control" [class.invalido]="
                  formularioTurno.get('tm_hora_inicio')?.invalid &&
                  formularioTurno.get('tm_hora_inicio')?.dirty
                "
              />
            }

            @if (
              formularioTurno.get('tm_hora_inicio')?.invalid &&
              formularioTurno.get('tm_hora_inicio')?.dirty
            ) {
              <small class="mensagem-validacao-form"> *{{ 'COMPONENTS.TURNOS_FORM.startHourRequired' | transloco }} </small>
            }
          </div>

          <div class="col-md-6">
            <label class="form-label">
              {{ 'COMPONENTS.TURNOS_FORM.endHourLabel' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="tm_hora_fim" type="time" class="input-form form-control" [class.invalido]="
                  formularioTurno.get('tm_hora_fim')?.invalid &&
                  formularioTurno.get('tm_hora_fim')?.dirty
                "
              />
            }

            @if (
              formularioTurno.get('tm_hora_fim')?.invalid &&
              formularioTurno.get('tm_hora_fim')?.dirty
            ) {
              <small class="mensagem-validacao-form"> *{{ 'COMPONENTS.TURNOS_FORM.endHourRequired' | transloco }} </small>
            }

            @if (
              formularioTurno.get('tm_hora_fim')?.invalid &&
              formularioTurno.get('tm_hora_fim')?.dirty
            ) {
              <small class="mensagem-validacao-form"> *{{ 'COMPONENTS.TURNOS_FORM.endHourRequired' | transloco }} </small>
            }
          </div>
        </div>

        <div class="buttons-form d-flex">
          <button class="btn-cancelar" type="button" (click)="cancelar()">
            <object class="me-2" data="assets/icone-fechar.svg" type="image/svg+xml"></object>
            {{ 'COMPONENTS.TURNOS_FORM.cancelButton' | transloco }}
          </button>

          <button type="button" class="btn-confirmar" [disabled]="botaoDesabilitado" [class.btn-confirmar-desabilitado]="botaoDesabilitado" (click)="onSubmit()">
            @if (loadingBotao) {
              <div class="spinner-border text-white spinner-border-sm" role="status">
                <span class="visually-hidden">
                  {{ 'COMPONENTS.TURNOS_FORM.loading' | transloco }}
                </span>
              </div>
            } @else {
              {{ turnoId ? ('COMPONENTS.TURNOS_FORM.updateButton' | transloco) : ('COMPONENTS.TURNOS_FORM.createButton' | transloco) }}
            }
          </button>
        </div>
      </form>
    </div>
  </section>
</main>
